import { bowTag, portsideTag, starboardTag } from '#details/constants';
import { SubmissionParseContext, useGenericPatchParser } from '#record/parser';
import { ModelParser, ParseContext } from 'apprise-frontend-parse/model';
import { useDefaultModelParser, useDefaultParser } from 'apprise-frontend-parse/resource';
import { useDefaultBookParser } from 'apprise-frontend-parse/workbook';
import { photographType } from './constants';
import { PhotographsJsonSerialization } from './jsonserializer';
import { newPhotoSlot, Photo, PhotographsPatch } from './model';

export const usePhotographsParser = () => {

 const modelparser: ModelParser<PhotographsPatch, ParseContext<SubmissionParseContext>> = useDefaultModelParser(usePhotographsItemParser())

  const bookparser = useDefaultBookParser(modelparser, photographType)

  return useDefaultParser({ modelparser, bookparser })

}


export const usePhotographsItemParser = () => {

  const parser = (row: PhotographsJsonSerialization) => {

    const { starboard, portside, bow } = row

    const photos: Photo[] = []

    starboard && photos.push({
      type: starboardTag,
      ref: starboard
    })

    portside && photos.push({
      type: portsideTag,
      ref: portside
    })

    bow && photos.push({
      type: bowTag,
      ref: bow
    })

    const patch: Partial<PhotographsPatch> = {

      patchedSlots: [photographType],

      [photographType]: {...newPhotoSlot(), photos}
    }

    return patch as PhotographsPatch
  }

  return useGenericPatchParser(parser)

}